import { Navigate, useParams } from "react-router-dom";
import { AppRoute } from "@/types/routes";
import { resolveProjectEntryPath } from "@/services/projectLastVisitedPanel";

/** Redirect `/projectId` → the last-visited panel (within 72h) or `/projectId/script` on first visit. */
const ProjectTabRedirect = () => {
  const { projectId } = useParams();

  if (projectId === undefined || projectId.length === 0) {
    return <Navigate to={AppRoute.Home} replace />;
  }

  return <Navigate to={resolveProjectEntryPath(projectId)} replace />;
};

export default ProjectTabRedirect;
